import { render, staticRenderFns } from "./ButtonGroupView.vue?vue&type=template&id=2d6cfd8c&scoped=true&"
import script from "./ButtonGroupView.vue?vue&type=script&lang=js&"
export * from "./ButtonGroupView.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGroupView.vue?vue&type=style&index=0&id=2d6cfd8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6cfd8c",
  null
  
)

export default component.exports